import { createFileRoute } from "@tanstack/react-router";
import ModuleCheckoutModal from "@/components/panel/ModuleCheckoutModal";

export const Route = createFileRoute("/test-modal-pro")({
  component: TestModalProPage,
});

function TestModalProPage() {
  return (
    <div className="p-8">
      <ModuleCheckoutModal
        open={true}
        onOpenChange={() => {}}
        moduleKey={null}
        moduleTitle="Club Pro"
        kind="pro"
      />
    </div>
  );
}
